module.exports = __webpack_public_path__ + "img/IMG_20200723_130329739.a01b1ce0.jpg";